import { Product } from '@gripp/shared-logic';
import { Button, Colors, RoutineButtonData } from '@gripp/shared-ui';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { StyleSheet } from 'react-native';
import { EditProductRoutineModal } from './editProductRoutineModal';

type EditProductRoutinesProps = {
  product: Product;
  productRoutines: RoutineButtonData[];
};

export const EditProductRoutines = ({
  product,
  productRoutines,
}: EditProductRoutinesProps) => {
  const { t } = useTranslation();

  const [editModalVisible, setEditModalVisible] = useState(false);

  const onPress = () => {
    setEditModalVisible(true);
  };

  return (
    <>
      <Button
        state='default'
        onPress={onPress}
        variant='rectangular'
      >
        {t('routines.editRoutines.title')}
      </Button>
      <EditProductRoutineModal
        product={product}
        productRoutines={productRoutines}
        isVisible={editModalVisible}
        onClose={() => setEditModalVisible(false)}
      />
    </>
  );
};

const styles = StyleSheet.create({
  editButton: {
    borderColor: Colors.primaryDark,
    borderWidth: 2,
    borderRadius: 8,
    height: 32,
    justifyContent: 'center',
    paddingHorizontal: 12,
  },
});
